import { z } from "zod";

export const STARTUP_STALL_TIMEOUT_MS = 20_000;
export const STARTUP_STALL_ENDPOINT = "/api/dashboard/startup-stall";

export const startupStallReportSchema = z.object({
  path: z.string().max(512),
  msSinceLoad: z.number().int().nonnegative(),
  visibility: z.string().max(16),
  everHidden: z.boolean(),
});
export type StartupStallReport = z.infer<typeof startupStallReportSchema>;

let startupComplete = false;

/** Record that the dashboard committed a render with the resolved session. */
export function markDashboardStartupComplete() {
  startupComplete = true;
}

export function isDashboardStartupComplete() {
  return startupComplete;
}
